import { api, endpoints } from '@/api'
import { BoxoAuthDTO, BoxoAuthPayload } from './boxoTypes'

export async function boxoAuth(payload: BoxoAuthPayload): Promise<BoxoAuthDTO> {
  const res = await api.post(endpoints.boxo.auth, payload)
  return res.data
}

export const boxoApi = {
  boxoAuth,
}
